import './audit-campaign-featured-card.scss'

import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { AuditCampaignFeatured } from '@skinsoft/types'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { Touchable } from '@skinsoft/ui'
import { Routes } from '../../../../router'

@Component({
    components: {
        sTouchable: Touchable
    },
    props: ['campaignFeatured', 'clickAction'],
    template: require('./audit-campaign-featured-card.html')
})
export class AuditCampaignFeaturedCard extends ReactiveVue {

    public campaignFeatured: AuditCampaignFeatured;
    
    private clickAction: string
    private ready: boolean = false;

    private openCampaign() {
        this.$router.push({ name: Routes.CAMPAIGN, params: { campaignId: this.campaignFeatured.id } });
    }

    private performClick() {
        switch(this.clickAction) {
            case 'addToCampaign':
                this.$emit('addToCampaign', this.campaignFeatured.id)
                break
            default:
                this.openCampaign()
        }
    }

    @Watch('campaignFeatured', { immediate: true })
    private onCampaignFeaturedChange() {
        this.ready = !!this.campaignFeatured;
    }

}